import { combineReducers } from '@reduxjs/toolkit';
import { all, fork } from 'redux-saga/effects';
import bagSlice from '@state/features/bag.slice';
import bagSaga from '@state/features/bag.saga';
export const bagRootReducer = combineReducers({
    bag: bagSlice.reducer,
});
export function* bagRootSaga() {
    yield all([fork(bagSaga)]);
}
